module.exports = __webpack_public_path__ + "img/icon-agile.65b57961.png";